import * as React from "react";
const Restore = (props) => (
  <svg
    width={260}
    height={260}
    viewBox="0 0 260 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M220.731 145.026V129.893C220.731 79.7571 179.984 39.1016 129.731 39.1016C116.06 39.0848 102.562 42.1518 90.2404 48.0741C77.919 53.9965 67.0923 62.6218 58.566 73.3079M39 114.949V130.081C39 180.274 79.7266 220.898 130 220.898C143.632 220.879 157.087 217.818 169.386 211.939C181.685 206.06 192.517 197.511 201.094 186.916"
      stroke="#313F78"
      strokeWidth={16.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.25 130L38.5938 107.656L61.9531 130M243.75 130L221.406 152.344L198.047 130"
      stroke="#313F78"
      strokeWidth={16.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Restore;
